const choices = {
    real: 'Régime réel',
    micro: 'Régime micro',
};

export default choices;
